export interface IFileReference {
  id: string,
  createdAt: number,
  origin: string,
  mimetype: string,
  originPath: string,
  sorting: number,
  size: number,
}


export class FileReference {

  public id: string;
  public name: string;
  public url: string;
  public sorting: number;

  constructor(data: IFileReference) {

    this.id = data.id;
    this.name = data.origin;
    this.url = data.originPath;
    this.sorting = data.sorting;
  }
}

export const createNewFileReference = (data: Partial<IFileReference> = {}): FileReference => new FileReference({
  id: data.id || 'new',
  createdAt: data.createdAt || Date.now(),
  origin: data.origin || '',
  originPath: data.originPath || '',
  mimetype: data.mimetype || '',
  sorting: data.sorting || 100,
  size: data.size || 0,
});
